<script>
import LeftPanel from '@/components/container/LeftPanel.vue';
import MainContainer from '@/components/container/MainContainer.vue';
import TestEmailsList from '@/components/page-test-emails/TestEmailsList.vue';
import TestEmailsHeader from '@/components/page-test-emails/TestEmailsHeader.vue';
import ButtonReturn from '@/components/left-panel/unique-buttons/ButtonReturn.vue';

export default {
    components: {
        LeftPanel,
        MainContainer,
        TestEmailsList,
        TestEmailsHeader,
        ButtonReturn,
    },
    async mounted() {
        // Load email mode and data
        await this.$store.dispatch('LOAD_EMAIL_MODE');
        if (this.$store.getters.IS_TEST_EMAILS_AVAILABLE) {
            await this.$store.dispatch('LOAD_SENT_EMAILS');
            await this.$store.dispatch('LOAD_EMAIL_STATS');
        } else {
            // Redirect if test email inspection is not available
            this.$router.push({ name: 'main' });
        }
    },
};
</script>

<template>
    <div class="page_container">
        <LeftPanel>
            <ButtonReturn />
        </LeftPanel>
        <MainContainer>
            <TestEmailsHeader />
            <TestEmailsList />
        </MainContainer>
    </div>
</template>
